import React from 'react';

const WorkOrderStep4Scheduling = ({ formData, setFormData, formErrors, maintenanceWindows }) => {
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  return (
    <div className="step-form">
      <div className="form-section">
        <h3 className="section-title">Scheduling</h3>
        <div className="row">
          <div className="form-group col-md-4">
            <label htmlFor="scheduledStartDate">Scheduled Start Date</label>
            <input
              type="date"
              id="scheduledStartDate"
              name="scheduledStartDate"
              value={formData.scheduledStartDate}
              onChange={handleChange}
            />
          </div>
          <div className="form-group col-md-4">
            <label htmlFor="scheduledStartTime">Scheduled Start Time</label>
            <input
              type="datetime-local"
              id="scheduledStartTime"
              name="scheduledStartTime"
              value={formData.scheduledStartTime}
              onChange={handleChange}
            />
          </div>
          <div className="form-group col-md-4">
            <label htmlFor="scheduledEndDate">Scheduled End Date</label>
            <input
              type="date"
              id="scheduledEndDate"
              name="scheduledEndDate"
              value={formData.scheduledEndDate}
              onChange={handleChange}
            />
          </div>
          <div className="form-group col-md-3">
            <label htmlFor="scheduledEndTime">Scheduled End Time</label>
            <input
              type="datetime-local"
              id="scheduledEndTime"
              name="scheduledEndTime"
              value={formData.scheduledEndTime}
              onChange={handleChange}
            />
          </div>
          <div className="form-group col-md-3">
            <label htmlFor="estimatedDurationHours">Estimated Duration (hours)</label>
            <input
              type="number"
              id="estimatedDurationHours"
              name="estimatedDurationHours"
              value={formData.estimatedDurationHours}
              onChange={handleChange}
              step="0.1"
              min="0"
            />
          </div>
          <div className="form-group col-md-3">
            <label htmlFor="maintenanceWindowId">Maintenance Window</label>
            <select
              id="maintenanceWindowId"
              name="maintenanceWindowId"
              value={formData.maintenanceWindowId}
              onChange={handleChange}
            >
              <option value="">Select Maintenance Window</option>
              {maintenanceWindows.map(window => (
                <option key={window.windowId} value={window.windowId}>
                  {window.windowName}
                </option>
              ))}
            </select>
          </div>
          <div className="form-group checkbox-group col-md-3">
            <input
              type="checkbox"
              id="isPlanned"
              name="isPlanned"
              checked={formData.isPlanned}
              onChange={handleChange}
            />
            <label htmlFor="isPlanned">Planned Work Order</label>
          </div>
        </div>



      </div>
    </div>
  );
};

export default WorkOrderStep4Scheduling;

